import React, { useEffect } from 'react';

import { DriversUploadDrawerInner } from '@futrli/shared-services/excel-upload/excel-modals/upload/drivers-upload-drawer-inner';

import { DriverControlBar } from '../../../components/driver-control-bar/driver-control-bar';
import { UpdateFromExcelModalContent } from '@futrli/shared-services/excel-upload';

import { CreateFromExcelModalContent } from '../../../components/excel-upload/create-from-excel-modal-content';
import { useDriverBuilderContext } from '../../../contexts/driver-builder-context/driver-builder-context';

interface ExcelDriverWizardScreenProps {
  onClose: () => void;
}

export const ExcelDriverWizardScreen = ({ onClose }: ExcelDriverWizardScreenProps) => {
  const { excelView, organisationId, sharedForm, workspaceId } = useDriverBuilderContext();

  const { handleInputMethodChange, inputMethod } = sharedForm;
  const { viewInstance, files, isFetchingFiles, isGeneratingTemplate, templateUrl } = excelView;

  useEffect(() => {
    if (!isFetchingFiles && !files.length && !templateUrl) {
      viewInstance.generateDriverTemplate();
    }
  }, [viewInstance, isFetchingFiles, files.length, templateUrl]);

  return (
    <>
      <DriversUploadDrawerInner
        isLoading={isFetchingFiles || isGeneratingTemplate}
        handleClose={onClose}
        workspaceId={workspaceId}
        organisationId={organisationId}
        onSuccess={() => Promise.resolve(onClose())}
        isUpdateDrawer={!!files.length}
        width={480}
      >
        <>
          <DriverControlBar
            inputMethod={inputMethod}
            isAddingNew={true}
            isDisabled={false}
            onInputMethodChange={handleInputMethodChange}
          />
          {files.length ? (
            <UpdateFromExcelModalContent
              workspaceId={workspaceId}
              organisationId={organisationId}
              config={{ entityType: 'driver' }}
              guidelinesUrl="http://support.futrli.com/en/articles/11326527-upload-non-financial-drivers-with-an-excel-spreadsheet"
            />
          ) : (
            <CreateFromExcelModalContent driverTemplateLink={templateUrl || ''} />
          )}
        </>
      </DriversUploadDrawerInner>
    </>
  );
};
